/* globals cc, SVGInjector*/
var EventEmitter = require('event-emitter');
var SizmekApi = require('./Sizmek');
var Messaging = require('../util/Messaging');
var Browser = require('../util/Browser');
var LocalStorage = require('../util/LocalStorage');
var VideoHandler = require('../util/VideoHandler');
var Tools = require('../util/Tools');

function Ad(config) {

	this.version = "1.0.9";

	console.log('[new Ad] ', this.version);

	this.event = new EventEmitter();
	window.cc = {}; //creatives content
	this.messaging = new Messaging();
	this.browser = Browser;
	this.sizmek = new SizmekApi(config);

	this.videoHandler;
	this.skipStartVideoRightAfterCollapse;
	this.resumeVideoOnMouseEnter;

	this.localStorage;

	this.status = {
		isAtTheEnd: false,
		currentCapping: -1,
		isCollapsed: true
	};

	this.initAd = function() {

		/*document.addEventListener('animationstart', function(event) {
			console.log('------------------> event.animationName ' + event.animationName);
		}, false);*/
		this.localStorage = new LocalStorage();

		this.status.currentCapping = this.localStorage.getData('hit');
		console.log('   > initAd : currentCapping ' + this.status.currentCapping);

		this.localStorage.incrementHit();

		//ré-injecter les SVG au DOM pour pouvoir les personaliser via CSS par la suite
		//ne peut fonctionner en locale que sous Firefox
		if (config.injectSvg && (Browser.isOnline || Browser.isFirefox)) {
			console.log('   > inject SVG... ');
			var mySVGsToInject = document.querySelectorAll('img.inject-me');
			if (mySVGsToInject.length === 0) {
				this.setupAd();
			} else {
				//la ligne suivant est jshint-ignorée afin de by-passer l'erreur nonew
				SVGInjector(mySVGsToInject, {}, this.setupAd.bind(this)); // jshint ignore:line
			}
		} else {
			if (config.injectSvg) console.log('   [warning] svg injection only work in Firefox local mode');
			this.setupAd();
		}
	};

	this.setupAd = function() {

		console.log('   > setupAd ');

		var nodeList = document.querySelectorAll('[data-cc],svg.injected-svg');
		var idList = '';
		var id = '';

		//cc : html  nodes with a data-cc attributes or svg.injected-svg class
		for (var element in nodeList) {
			id = nodeList[element].id;
			if (id) {
				window.cc[id] = nodeList[element];
				idList += id + ', ';
			}
		}

		if (!cc.ad) console.error('"ad" div must be flagged with a data-cc attributes !');

		console.log('   > available creative content ( @see ad.cc ) : ' + idList);

		this.addEventListeners();
		this.initMessaging();

		this.videoHandler = new VideoHandler([cc.video, cc.videoExpand], config, this.event, this.sizmek, this.messaging);

		if (config.collapseOnVideoEnd !== false) {
			this.event.on('VIDEO_EXPAND_END', this.collapse.bind(this));
		}

		this.event.on('VIDEO_END', function() {
			this.status.isAtTheEnd = true;
		}.bind(this));

		this.event.on('VIDEO_PLAY', function() {
			this.status.isAtTheEnd = false;
		}.bind(this));

		console.log('   [event] Ad::START_AD ');
		this.event.emit('START_AD', this);

		//TMP, en attendant les décisions sur le autoFrequencyCapping et comment les TM peuvent l'utiliser
		if (this.getCurrentScenario().autoExpand === true) {
			this.localStorage.incrementAutoExpand();
			this.expand();
		}

	};

	this.getCurrentScenario = function() {
		if (config.scenarioCapping) {
			//item correspondant au capping ou dernier item de la liste ?
			var capping = this.status.currentCapping;
			var scenarioIndex = (config.scenarioCapping[capping]) ? capping : config.scenarioCapping.length - 1;
			return config.scenarioCapping[scenarioIndex];
		} else {
			return {};
		}
	};

	this.replay = function(e) {
		if (e) e.stopPropagation();

		if (cc.replay) cc.replay.style.display = 'none';

		if (cc.expand) cc.expand.style.display = 'block';

		console.log('   [event] Ad::REPLAY_AD ');
		this.event.emit('REPLAY_AD', this);

		if (config.expandOnReplay) this.expand();

	};

	this.addEventListeners = function() {

		console.log('   > addEventListeners (ad, pause, play, sound, mute, replay, ...)');

		if (cc.ad) {
			cc.ad.addEventListener('click', this.clickthrough.bind(this), false); //click global
			cc.ad.addEventListener('mouseenter', this.onMouseEnterAd.bind(this), false);
			cc.ad.addEventListener('mouseleave', this.onMouseLeaveAd.bind(this), false);
		}

		var _this = this;

		if (cc.replay) cc.replay.addEventListener('click', this.replay.bind(this));

		if (cc.expand) cc.expand.addEventListener('click', function(e) {
			e.stopPropagation();
			_this.expand();
		});

		if (cc.close) cc.close.addEventListener('click', function(e) {
			e.stopPropagation();
			_this.collapse();
		});

	};

	this.onMouseEnterAd = function(e) {
		e.stopPropagation();

		if (this.resumeVideoOnMouseEnter) {
			//TODO ARG PASSS
			this.resumeVideoOnMouseEnter.play();
			this.resumeVideoOnMouseEnter = null;
		}

		if (config.expandOnRollOver && !this.status.isAtTheEnd) this.expand();

		console.log('   [event] Ad::MOUSE_ENTER_AD ');
		this.event.emit('MOUSE_ENTER_AD', this);
	};

	this.onMouseLeaveAd = function(e) {
		e.stopPropagation();

		console.log('   [event] Ad::MOUSE_LEAVE_AD ');

		if (this.getCurrentScenario().collapseOnRollOut === true && !this.skipStartVideoRightAfterCollapse) {
			console.log('   > collapse on mouse leave');
			this.collapse();
		}

		if (config.collapseOnRollOut) this.collapse();

		console.log('   [event] Ad::MOUSE_LEAVE_AD ');
		this.event.emit('MOUSE_LEAVE_AD', this);
	};

	this.initMessaging = function() {
		var _this = this;

		this.messaging.addMessageListener('pauseVideo', function() {
			if (cc.video) cc.video.pause();
			if (cc.videoExpand) cc.videoExpand.pause();
		});

		this.messaging.addMessageListener('expandFormat', function() {
			_this.expand();
		});

		this.messaging.addMessageListener('rollout', function() {
			_this.collapse();
		});

		//TODO : warning scope ?
		document.addEventListener('mousemove', function(e) {
			_this.messaging.dispatchMessage('moveEvent', {
				clientX: e.pageX || e.clientX,
				clientY: e.pageY || e.clientY
			});
		});
	};

	this.startVideo = function(video, videoFadeInDelay) {

		if (this.skipStartVideoRightAfterCollapse && (new Date().getTime() - this.skipStartVideoRightAfterCollapse) < 1000) {
			this.skipStartVideoRightAfterCollapse = null;
			this.resumeVideoOnMouseEnter = video;
			console.log('   [SKIP] startVideo() after collapse ');
			return;
		}

		this.videoHandler.startVideo(video, videoFadeInDelay);
	};

	this.preventExpand = function() {
		console.log('   [prevent] expand ');
		this.status.preventExpand = true;
	};

	this.expand = function(uncancelable, ebParam) {

		if (uncancelable !== true) this.event.emit('BEFORE_EXPAND_AD', this);

		if (!this.status.isCollapsed) return;

		if (this.status.preventExpand) {
			this.status.preventExpand = false;
			console.log('   > expand cancel');
			return;
		} else {
			console.log('   > expand');
		}

		Tools.removeClass(cc.ad, 'collapseSize');
		Tools.setClass(cc.ad, 'expandSize');

		this.sizmek.expand(ebParam);
		this.status.isCollapsed = false;

		this.messaging.dispatchMessage('expand');

		console.log('   [event] Ad::EXPAND_AD ');
		this.event.emit('EXPAND_AD', this);
	};

	this.preventCollapse = function() {
		console.log('   [prevent] collapse ');
		this.status.preventCollapse = true;
	};

	this.collapse = function(uncancelable, ebParam) {

		if (uncancelable !== true) this.event.emit('BEFORE_COLLAPSE_AD', this);

		if (this.status.isCollapsed) return;

		if (this.status.preventCollapse) {
			this.status.preventCollapse = false;
			console.log('   > collapse cancel');
			return;
		} else {
			console.log('   > collapse');
		}

		this.sizmek.collapse(ebParam);

		if (cc.expand) cc.expand.display = 'block';

		if (!config.pushdownSettings || !config.pushdownSettings.collapseDuration || config.pushdownSettings.collapseDuration <= 0) {
			this.collapseNow();
		} else {
			setTimeout(this.collapseNow.bind(this), config.pushdownSettings.collapseDuration + 100);
		}
	};

	this.collapseNow = function() {
		Tools.removeClass(cc.ad, 'expandSize');
		Tools.setClass(cc.ad, 'collapseSize');

		this.status.isCollapsed = true;

		this.messaging.dispatchMessage('collapse');

		console.log('   [event] Ad::COLLAPSE_AD ');
		this.event.emit('COLLAPSE_AD', this);
	};

	this.clickthrough = function(e) {
		console.log('   > clickthrough (internal) ');
		e.stopPropagation();

		//if (e.target instanceof HTMLVideoElement) e.target.pause();
		if (cc.video) cc.video.pause();
		if (cc.videoExpand) cc.videoExpand.pause();

		this.event.emit('CLICK_AD', e);

		this.skipStartVideoRightAfterCollapse = new Date().getTime();
		this.collapse();

	};

	this.sizmek.config = config;
	this.sizmek.event.on('INIT_AD', this.initAd.bind(this));
	this.sizmek.event.on('EXPAND_AD', this.expand.bind(this)); //callback des autoExpandFrequencyCapping
	this.sizmek.event.on('COLLAPSE_AD', this.collapse.bind(this)); //callback des autoExpandFrequencyCapping

}

module.exports = Ad;
